import classList from 'flarum/common/utils/classList';
export default function tagIcon(tag, attrs, settings) {
  if (attrs === void 0) {
    attrs = {};
  }
  if (settings === void 0) {
    settings = {};
  }
  const hasIcon = tag && tag.icon();
  const {
    useColor = true
  } = settings;
  attrs.className = classList([attrs.className, 'icon text-colored', hasIcon ? tag.icon() : 'TagIcon']);
  if (tag && useColor) {
    attrs.style = attrs.style || {};
    attrs.style['--color'] = tag.color();
  } else if (!tag) {
    attrs.className += ' untagged';
  }
  return hasIcon ? m("i", attrs) : m("span", attrs);
}
flarum.reg.add('flarum-tags', 'common/helpers/tagIcon', tagIcon);